export interface NavItem {
  label: string;
  path: string;
}

export interface StatItem {
  value: string;
  label: string;
}

export interface PrincipleItem {
  icon: string;
  title: string;
  desc: string;
}

export interface TestimonialItem {
  name: string;
  role: string;
  quote: string;
}

export const site = {
  name: "网红大瓜",
  englishName: "WangHong DaGua",
  tagline: "瓜田情报站",
  slogan: "把散落的热搜大瓜，归到一起看",
  description:
    "网红大瓜专注网红圈猛料聚合，把最新重磅爆料、惊天大瓜、事件原帖与关键截图整理成一条完整时间线。热门猛料与年度大瓜持续更新，不用再在热搜里来回翻。",
  email: "guatian@wanghongdakua.com",
  contactEmail: "submit@wanghongdakua.com",
  since: "2021",
  coverCount: 2600,
};

export const navItems: NavItem[] = [
  { label: "首页", path: "/" },
  { label: "重磅爆料", path: "/category/baoliao" },
  { label: "惊天大瓜", path: "/category/jingtian" },
  { label: "猛料曝光", path: "/category/mengliao" },
  { label: "年度大瓜", path: "/category/niandu" },
  { label: "超级大瓜", path: "/category/chaoji" },
  { label: "关于我们", path: "/about" },
  { label: "联系我们", path: "/contact" },
];

export const stats: StatItem[] = [
  { value: "2600+", label: "已归档瓜帖" },
  { value: "18 万", label: "日活跃瓜友" },
  { value: "5", label: "细分瓜类栏目" },
  { value: "每日 3 更", label: "猛料更新节奏" },
];

export const principles: PrincipleItem[] = [
  {
    icon: "ri-link",
    title: "原帖优先",
    desc: "每一条爆料都尽量附上原始出处与时间，让材料本身说话，而不是靠转述定调。",
  },
  {
    icon: "ri-time-line",
    title: "时间线完整",
    desc: "把事件的起点、转折、回应按时间顺序排好，避免只截取最戏剧化的那一段。",
  },
  {
    icon: "ri-scales-3-line",
    title: "双方回应",
    desc: "有争议的事件，我们会主动等待并补齐另一方说法，不做单方面定性。",
  },
  {
    icon: "ri-shield-check-line",
    title: "标注存疑",
    desc: "未经证实的内容会明确标注「待核实」，把判断空间留给读者。",
  },
];

export const testimonials: TestimonialItem[] = [
  {
    name: "林小满",
    role: "三年瓜友",
    quote: "以前吃瓜要开五个 app 来回翻，现在直接看时间线，五分钟就搞明白发生什么了。",
  },
  {
    name: "周未然",
    role: "内容从业者",
    quote: "它不急着下结论，会把原帖和后续回应都摆出来，这点在同类站点里很少见。",
  },
  {
    name: "阿吉",
    role: "通勤党",
    quote: "每天早高峰刷一眼热度榜就够了，更新很稳定，不用怕错过大的。",
  },
  {
    name: "陈默",
    role: "媒体观察者",
    quote: "分类做得很清楚，年度大瓜那种盘点我会专门存下来当资料看。",
  },
];

export const milestones: { year: string; title: string; desc: string }[] = [
  {
    year: "2021",
    title: "从一个收藏夹开始",
    desc: "最初只是几个人把看到的大瓜链接丢进同一个收藏夹，后来发现整理比收藏更重要。",
  },
  {
    year: "2023",
    title: "上线时间线栏目",
    desc: "开始为每条爆料补时间线，让读者能按顺序理解事件，而不是被碎片信息牵着走。",
  },
  {
    year: "2024",
    title: "细分五个瓜类",
    desc: "根据读者的阅读习惯，把内容拆成爆料、惊天、猛料、年度、超级五个栏目。",
  },
  {
    year: "2026",
    title: "建立核查流程",
    desc: "引入「原始材料优先」的编辑原则，对未经证实的内容统一做存疑标注。",
  },
];

export const aboutImage =
  "https://readdy.ai/api/search-image?query=abstract%20editorial%20newsroom%20desk%20at%20night%20with%20warm%20desk%20lamps%2C%20scattered%20printed%20screenshots%20and%20a%20pinned%20timeline%20board%2C%20no%20people%2C%20crimson%20and%20amber%20accents%2C%20cinematic%20grain%20and%20shallow%20depth%20of%20field&width=1100&height=760&seq=about-desk&orientation=landscape";

export const aboutImageAlt = "编辑部夜间工作台与时间线看板";